import React from 'react'

export const VendorDetail = () => {
    return <div>VendorDetail</div>
}
